document.addEventListener("DOMContentLoaded", function () {
	const filterWrapper = document.querySelector(".semmel-connect--filter");
	const tourFilterWrapper = document.querySelector(".semmel-connect--filter-tour");
	const filterItems = filterWrapper.querySelectorAll("li");
	const tourFilterItems = tourFilterWrapper
		? tourFilterWrapper.querySelectorAll("li")
		: [];
	const eventsContainer = document.querySelector(".semmel-connect--events");
	const events = eventsContainer.querySelectorAll(".semmel-connect--event");
	const eventsPerPage = 8;
	let currentPage = 1;
	let selectedLocation = "all";
	let selectedTour = "all";
	let searchQuery = "";

	const locationCounts = new Map();
	const tourCounts = new Map();

	Array.from(events).forEach((event) => {
		const location = event.getAttribute("data-location");
		const tour = event.getAttribute("data-tour");
		if (location) {
			locationCounts.set(location, (locationCounts.get(location) || 0) + 1);
		}
		if (tour) {
			tourCounts.set(tour, (tourCounts.get(tour) || 0) + 1);
		}
	});

	// Suchfeld erstellen und einfügen
	const searchWrapper = document.createElement("div");
	searchWrapper.className = "semmel-connect--search";
	const searchInput = document.createElement("input");
	searchInput.type = "text";
	searchInput.placeholder = "Search by city...";
	searchInput.className = "semmel-connect--search-input";
	searchInput.setAttribute("autocomplete", "off");
	
	const suggestionsBox = document.createElement("div");
	suggestionsBox.className = "semmel-connect--suggestions";
	
	searchWrapper.appendChild(searchInput);
	searchWrapper.appendChild(suggestionsBox);
	
	// Füge Suchfeld NACH der Navigation ein
	const navElement = filterWrapper.parentElement;
	navElement.parentElement.insertBefore(searchWrapper, navElement.nextSibling);

	// Extrahiere alle verfügbaren Städte
	const cities = new Set();
	events.forEach((event) => {
		const addressElement = event.querySelector(".semmel-connect--event-address");
		if (addressElement) {
			// Hole den vollen Text und teile an Zeilenumbrüchen (durch <br> verursacht)
			const fullText = addressElement.innerText || addressElement.textContent;
			const lines = fullText.split('\n').map(line => line.trim()).filter(line => line);
			
			if (lines.length >= 2) {
				// Zweite Zeile enthält "Stadt, Land" - nehme die komplette Zeile
				const cityLine = lines[1];
				if (cityLine) {
					// Füge Venue-Namen und Stadt zusammen: "Venue Stadt"
					const venue = lines[0];
					const cityPart = cityLine.split(',')[0].trim(); // Stadt ohne Land
					cities.add(`${venue} ${cityPart}`);
				}
			}
		}
	});
	const cityList = Array.from(cities).sort();

	// Auto-Suggestion Funktion
	function showSuggestions(value) {
		suggestionsBox.innerHTML = "";
		if (!value) {
			suggestionsBox.style.display = "none";
			return;
		}

		const matches = cityList.filter(city => 
			city.toLowerCase().includes(value.toLowerCase())
		).slice(0, 8);

		if (matches.length > 0) {
			matches.forEach(city => {
				const suggestion = document.createElement("div");
				suggestion.className = "semmel-connect--suggestion-item";
				suggestion.textContent = city;
				suggestion.addEventListener("click", () => {
					searchInput.value = city;
					// Verwende den kompletten Text für die Suche
					searchQuery = city.toLowerCase();
					suggestionsBox.style.display = "none";
					currentPage = 1;
					showEvents(currentPage);
				});
				suggestionsBox.appendChild(suggestion);
			});
			suggestionsBox.style.display = "block";
		} else {
			suggestionsBox.style.display = "none";
		}
	}

	// Such-Event-Listener
	searchInput.addEventListener("input", (e) => {
		const value = e.target.value.trim();
		searchQuery = value.toLowerCase();
		showSuggestions(value);
		currentPage = 1;
		showEvents(currentPage);
	});

	// Schließe Suggestions bei Klick außerhalb
	document.addEventListener("click", (e) => {
		if (!searchWrapper.contains(e.target)) {
			suggestionsBox.style.display = "none";
		}
	});

	// Fokus zeigt Suggestions
	searchInput.addEventListener("focus", () => {
		if (searchInput.value) {
			showSuggestions(searchInput.value);
		}
	});

	// 🔍 Vorauswahl basierend auf URL nur wenn Tour-Filter vorhanden ist
	if (tourFilterItems.length > 0) {
		const pathname = window.location.pathname;
		if (pathname.includes('/and-a-new-dimension')) {
			selectedTour = "A New Dimension";
		} else if (pathname.includes('/the-immersive-symphony')) {
			selectedTour = "The Immersive Symphony";
		}
	}

	// Scroll-Buttons für Location-Filter
	const prevButton = document.createElement("button");
	const nextButton = document.createElement("button");
	prevButton.textContent = "⇠";
	nextButton.textContent = "⇢";
	prevButton.className = "filter-nav-button prev";
	nextButton.className = "filter-nav-button next";

	filterWrapper.parentElement.insertBefore(prevButton, filterWrapper);
	filterWrapper.parentElement.insertBefore(
		nextButton,
		filterWrapper.nextSibling
	);

	filterWrapper.style.overflowX = "auto";
	filterWrapper.style.whiteSpace = "nowrap";

	const scrollAmount = 362;
	prevButton.addEventListener("click", () => {
		filterWrapper.scrollBy({ left: -scrollAmount, behavior: "smooth" });
	});
	nextButton.addEventListener("click", () => {
		filterWrapper.scrollBy({ left: scrollAmount, behavior: "smooth" });
	});

	function hideFiltersWithoutFutureEvents() {
		filterItems.forEach((item) => {
			const location = item.getAttribute("data-location");
			if (location === "all") {
				item.style.display = "inline-block";
				return;
			}

			const hasUpcoming = (locationCounts.get(location) || 0) > 0;
			item.style.display = hasUpcoming ? "inline-block" : "none";

			if (!hasUpcoming && item.classList.contains("active")) {
				item.classList.remove("active");
				selectedLocation = "all";
				filterWrapper
					.querySelector('li[data-location="all"]')
					?.classList.add("active");
			}
		});

		tourFilterItems.forEach((item) => {
			const tour = item.getAttribute("data-tour");
			if (tour === "all") {
				item.style.display = "inline-block";
				return;
			}

			const hasUpcoming = (tourCounts.get(tour) || 0) > 0;
			item.style.display = hasUpcoming ? "inline-block" : "none";

			if (!hasUpcoming && item.classList.contains("active")) {
				item.classList.remove("active");
				selectedTour = "all";
				tourFilterWrapper
					?.querySelector('li[data-tour="all"]')
					?.classList.add("active");
			}
		});
	}

	hideFiltersWithoutFutureEvents();

	function showEvents(page) {
		const start = (page - 1) * eventsPerPage;
		const end = start + eventsPerPage;
		let visibleCount = 0;

		// Entferne vorherige "Keine Ergebnisse" Nachricht
		const existingNoResults = eventsContainer.querySelector('.no-results-message');
		if (existingNoResults) {
			existingNoResults.remove();
		}

		events.forEach((event) => {
			const eventLocation = event.getAttribute("data-location");
			const eventTour = event.getAttribute("data-tour");
			const addressElement = event.querySelector(".semmel-connect--event-address");
			const searchText = event.getAttribute("data-search");
			const fullText = (searchText || (addressElement ? (addressElement.innerText || addressElement.textContent) : ""))
				.toLowerCase()
				.replace(/\s+/g, " ")
				.trim();

			const matchesLocation =
				selectedLocation === "all" || eventLocation === selectedLocation;
			const matchesTour = selectedTour === "all" || eventTour === selectedTour;
			
			// Flexible Suche: Suche nach jedem Wort einzeln
			let matchesSearch = searchQuery === "";
			if (!matchesSearch && searchQuery) {
				const searchWords = searchQuery.split(' ').filter(w => w.length > 0);
				// Event matcht wenn ALLE Suchwörter im Text vorkommen
				matchesSearch = searchWords.every(word => fullText.includes(word));
			}

			if (matchesLocation && matchesTour && matchesSearch) {
				if (visibleCount >= start && visibleCount < end) {
					event.classList.remove("is-style-hidden");
				} else {
					event.classList.add("is-style-hidden");
				}
				visibleCount++;
			} else {
				event.classList.add("is-style-hidden");
			}
		});

		// Zeige "Keine Ergebnisse" Nachricht wenn nichts gefunden wurde
		if (visibleCount === 0 && searchQuery) {
			const noResultsMsg = document.createElement('div');
			noResultsMsg.className = 'no-results-message';
			noResultsMsg.innerHTML = `<p>Keine Ergebnisse für "${searchInput.value}" gefunden.</p>`;
			eventsContainer.appendChild(noResultsMsg);
		}

		const showMoreButton = document.querySelector(".show-more-button");
		if (!showMoreButton && visibleCount > end) {
			const button = document.createElement("button");
			button.textContent = "LOAD MORE";
			button.className = "show-more-button";
			button.addEventListener("click", () => {
				events.forEach((event) => {
					const eventLocation = event.getAttribute("data-location");
					const eventTour = event.getAttribute("data-tour");
					const addressElement = event.querySelector(".semmel-connect--event-address");
					const searchText = event.getAttribute("data-search");
					const fullText = (searchText || (addressElement ? (addressElement.innerText || addressElement.textContent) : ""))
						.toLowerCase()
						.replace(/\s+/g, " ")
						.trim();
					
					let matchesSearch = searchQuery === "";
					if (!matchesSearch && searchQuery) {
						const searchWords = searchQuery.split(' ').filter(w => w.length > 0);
						matchesSearch = searchWords.every(word => fullText.includes(word));
					}
					
					if (
						(selectedLocation === "all" ||
							eventLocation === selectedLocation) &&
						(selectedTour === "all" || eventTour === selectedTour) &&
						matchesSearch
					) {
						event.classList.remove("is-style-hidden");
					}
				});
				button.remove();
			});
			eventsContainer.parentElement.insertBefore(
				button,
				eventsContainer.nextSibling
			);
		} else if (showMoreButton && visibleCount <= end) {
			showMoreButton.remove();
		}
	}

	// Länder-Filter
	filterItems.forEach((filterItem) => {
		filterItem.addEventListener("click", () => {
			selectedLocation = filterItem.getAttribute("data-location");

			filterItems.forEach((item) => item.classList.remove("active"));
			filterItem.classList.add("active");

			// Dynamische Touren-Anpassung basierend auf gewähltem Land
			tourFilterItems.forEach((item) => {
				const tour = item.getAttribute("data-tour");
				if (tour === "all") {
					item.style.display = "inline-block";
					item.style.width = "66.66%";
					return;
				}

				const hasMatch = Array.from(events).some((event) => {
					return (
						event.getAttribute("data-tour") === tour &&
						(selectedLocation === "all" ||
							event.getAttribute("data-location") === selectedLocation)
					);
				});

				item.style.display = hasMatch ? "inline-block" : "none";
			});

			// Breitenregel bei genau 2 sichtbaren Touren
			const visibleTourItems = Array.from(tourFilterItems).filter(
				item => window.getComputedStyle(item).display !== 'none'
			);
			if (visibleTourItems.length === 2) {
				visibleTourItems.forEach(item => (item.style.width = '66.66%'));
			} else {
				tourFilterItems.forEach(item => (item.style.width = ''));
			}

			currentPage = 1;
			showEvents(currentPage);
		});
	});

	// Tour-Filter
	tourFilterItems.forEach((tourItem) => {
		tourItem.addEventListener("click", () => {
			selectedTour = tourItem.getAttribute("data-tour");

			tourFilterItems.forEach((item) => item.classList.remove("active"));
			tourItem.classList.add("active");

			// Dynamische Länder-Anpassung basierend auf gewählter Tour
			filterItems.forEach((item) => {
				const location = item.getAttribute("data-location");
				if (location === "all") {
					item.style.display = "inline-block";
					return;
				}

				const hasMatch = Array.from(events).some((event) => {
					return (
						event.getAttribute("data-location") === location &&
						(selectedTour === "all" ||
							event.getAttribute("data-tour") === selectedTour)
					);
				});

				item.style.display = hasMatch ? "inline-block" : "none";
			});

			currentPage = 1;
			showEvents(currentPage);
		});
	});

	// Initialer Tour-Filter (falls per URL gesetzt)
	if (selectedTour !== "all") {
		tourFilterItems.forEach((item) => {
			item.classList.toggle(
				"active",
				item.getAttribute("data-tour") === selectedTour
			);
		});

		// Länder an Tour anpassen
		filterItems.forEach((item) => {
			const location = item.getAttribute("data-location");
			if (location === "all") {
				item.style.display = "inline-block";
				return;
			}

			const hasMatch = Array.from(events).some((event) => {
				return (
					event.getAttribute("data-location") === location &&
					event.getAttribute("data-tour") === selectedTour
				);
			});

			item.style.display = hasMatch ? "inline-block" : "none";
		});
	}

	function preselectLocationByIp() {
		if (selectedLocation !== "all" || typeof fetch !== "function") {
			return;
		}

		fetch("https://ipapi.co/json/", {
			method: "GET",
			headers: { Accept: "application/json" },
		})
			.then((response) => (response.ok ? response.json() : null))
			.then((payload) => {
				if (!payload || selectedLocation !== "all") {
					return;
				}

				const candidates = [];
				if (payload.country_name) {
					candidates.push(payload.country_name.toLowerCase());
				}
				if (payload.country) {
					candidates.push(payload.country.toLowerCase());
				}

				if (!candidates.length) {
					return;
				}

				const target = Array.from(filterItems).find((item) => {
					const value = item.getAttribute("data-location");
					if (!value || value === "all") {
						return false;
					}

					if ((locationCounts.get(value) || 0) === 0) {
						return false;
					}
					return candidates.includes(value.toLowerCase());
				});

				if (target) {
					target.click();
				}
			})
			.catch(() => {});
	}

	preselectLocationByIp();
	showEvents(currentPage);

	// Klick auf Event führt zum Ticketlink
	events.forEach((event) => {
		const ticketLink = event.querySelector("a");
		if (ticketLink) {
			event.style.cursor = "pointer";
			event.addEventListener("click", () => {
				window.open(ticketLink.href, "_blank");
			});
		}
	});
});